<template>
    <div class="inputarea">
      <div>
        <p>あああ{{ this.$pa.n1 }}</p>
        <p>えええ{{ aa }}</p>
      </div>
  </div>
</template>

<script>

export default {
  data(){
    return{
      aa: "樋口 二郎",
    }
  },
  computed:{
    mojibunkatu:function(){
      var bunkatu = this.aa.split('');
      return bunkatu
    },
  }  

};


</script>

<style>
.inputarea{
      font-family: -apple-system, "Segoe UI", "Helvetica Neue", "Hiragino Kaku Gothic ProN", メイリオ, meiryo, sans-serif;
      line-height: 11pt;
}

</style>



// WEBPACK FOOTER //
// src/components/InputData.vue